import React, { useEffect, useState, useContext } from "react";
import { utils, writeFile } from "xlsx";
import { BACKEND_API } from "../../constants/backendApi";

//Style
// import "./CurrentCreditBody.css";

//Components
import CreditDetailsTableComponent from "../CreditDetailsTableComponent/CreditDetailsTableComponent";

//Context
import { LoadingContext } from "../../context/LoadingContext";

//hooks
import useDebounce from "../../hooks/useDebounce";

const CreditManagerBody = ({ userData }) => {
  const { setLoading } = useContext(LoadingContext);

  const [maxData, setMaxData] = useState(10);

  const [initPage, setInitPage] = useState(0);

  const [creditList, setCreditList] = useState([]);

  const [creditListExcel, setCreditListExcel] = useState([]);

  const [totalCredits, setTotalCredits] = useState(0);

  const [years, setYears] = useState([]);

  const [, setTotalCurrentLoans] = useState(0);

  const [totalCurrentCredit, setTotalCurrentCredit] = useState(0);

  const [totalDelinquentLoans, setTotalDelinquentLoans] = useState(0);

  const [totalCreditInProcess, setTotalCreditInProcess] = useState(0);

  const [filterData, setFilterData] = useState({
    type: "",
    document_plate: "",
    advisor: "",
    insurer: "",
    credit_state: "",
    next_to_renew: "",
    credit_type: "loans_process",
    year: new Date().getFullYear(),
  });

  const tableFields = [
    {
      name: "Altura",
    },
    {
      name: "Nombre Cliente",
    },
    {
      name: "Vigencia Inicial",
    },
    {
      name: "No. de Documento",
    },
    {
      name: "Placa/Detalle de Riesgo",
    },
    {
      name: "No. de Poliza",
    },
  ];

  const token = localStorage.getItem("token");

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearOptions = [];

    for (let year = 2020; year <= currentYear; year++) {
      yearOptions.push(
        <option key={year} value={year}>
          {year}
        </option>
      );
    }

    setYears(yearOptions);

    try {
      const selectInsurer = document.getElementById("insurer");

      fetch(`${BACKEND_API}/api/insurance-companies`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then(({ data }) => {
          data.map((insurer) => {
            const option = document.createElement("option");
            option.text = insurer.NombreAseguradora;
            option.value = insurer.IdAseguradora;
            selectInsurer?.appendChild(option);

            const optionsArray = Array.from(selectInsurer?.options ?? []);

            return optionsArray.sort((a, b) => a.text.localeCompare(b.text));
          });
        });
    } catch (err) {
      console.log(err);
    }

    const filterCurrentCreditBody = {
      userDocument: filterData.document_plate,
      anio: filterData.year,
      paginado: "999999",
      offset: "0",
    };

    try {
      fetch(`${BACKEND_API}/api/credit-current-all`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(filterCurrentCreditBody),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data?.message === "informacion creditos vigentes") {
            setTotalCurrentCredit(data.data.cantRegistros);
          } else {
            setTotalCurrentCredit(0);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
    }

    const filterDelinquentLoansBody = {
      Filtro: filterData.document_plate,
      EstadoConsulta: "",
      IdAseguradora: filterData.insurer,
      Estado: "",
      AllData: true,
      Renovacion: false,
      Mora: true,
      EnProceso: false,
      NumeroRegistros: maxData,
      Inicial: initPage,
      Anio: "0",
      Mes: "0",
    };

    try {
      fetch(`${BACKEND_API}/api/credits`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(filterDelinquentLoansBody),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.message === "informacion creditos") {
            setTotalDelinquentLoans(data.data.TotalRegistros);
          } else {
            setTotalDelinquentLoans(0);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
    }

    const filterCreditInProcessBody = {
      Filtro: filterData.document_plate,
      EstadoConsulta: "",
      IdAseguradora: filterData.insurer,
      Estado: "",
      AllData: true,
      Renovacion: false,
      Mora: false,
      EnProceso: true,
      NumeroRegistros: maxData,
      Inicial: initPage,
      Anio: "0",
      Mes: "0",
    };

    try {
      fetch(`${BACKEND_API}/api/credits`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(filterCreditInProcessBody),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.message === "informacion creditos") {
            setTotalCreditInProcess(data.data.TotalRegistros);
          } else {
            setTotalCreditInProcess(0);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
    }
  }, [
    filterData?.document_plate,
    filterData?.insurer,
    filterData?.year,
    initPage,
    maxData,
    token,
    setLoading,
  ]);

  const debouncedSearch = useDebounce((filterData) => {
    setLoading(true);

    if (
      filterData.credit_type === "loans_process" ||
      filterData.credit_type === "delinquent_loans"
    ) {
      const filterBody = {
        Filtro: filterData.document_plate,
        EstadoConsulta: "",
        IdAseguradora: filterData.insurer,
        Estado: "",
        AllData: false,
        Renovacion: false,
        Mora: filterData.credit_type === "delinquent_loans" ? true : false,
        EnProceso: filterData.credit_type === "loans_process" ? true : false,
        NumeroRegistros: maxData,
        Inicial: initPage,
        Anio: "0",
        Mes: "0",
      };
      try {
        fetch(`${BACKEND_API}/api/credits`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(filterBody),
        })
          .then((res) => res.json())
          .then(({ data }) => {
            if (data.Creditos) {
              const creditsNewArr = data.Creditos.map((credit) => [
                {
                  field_content: credit.NumCuota + " de " + credit.No_Cuotas,
                },
                {
                  field_content: credit.NombreCliente
                    ? credit.NombreCliente
                    : "N/A",
                },
                {
                  field_content: credit.Inicio_poliza
                    ? credit.Inicio_poliza
                    : "N/A",
                },
                {
                  field_content: credit.Document ? credit.Document : "N/A",
                },
                {
                  field_content: credit.Placa
                    ? credit.Placa
                    : credit.detalleRiesgo
                    ? credit.detalleRiesgo
                    : "N/A",
                },
                {
                  field_content: credit.NoPoliza ? credit.NoPoliza : "N/A",
                },
              ]);

              setTotalCredits(data.TotalRegistros);
              setCreditList(creditsNewArr);
            } else {
              setCreditList([]);
              setTotalCredits(0);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (err) {
        console.log(err);
      }
    }

    const filterBody = {
      userDocument: filterData.document_plate,
      anio: String(filterData.year),
      paginado: String(maxData),
      offset: String(initPage),
    };

    if (filterData.credit_type === "current_loans") {
      try {
        fetch(`${BACKEND_API}/api/credit-current-all`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(filterBody),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.message === "informacion creditos vigentes") {
              const creditsNewArr = data.data.listaCreditosRet.map((credit) => [
                {
                  field_content: credit.altura + " de " + credit.altura,
                },
                {
                  field_content: credit.NombreCliente,
                },
                {
                  field_content: credit.vigInicial,
                },
                {
                  field_content: credit.noDoc,
                },
                {
                  field_content: credit.riesgo,
                },
                {
                  field_content: credit.poliza,
                },
              ]);

              setTotalCredits(data.data.cantRegistros);
              setCreditList(creditsNewArr);
            } else {
              setCreditList([]);
              setTotalCredits(0);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (err) {
        console.log(err);
      }
    }

    // if (filterData.credit_type === "cancelled_loans") {
    //   try {
    //     fetch(`${BACKEND_API}/api/credit-canceled-all`, {
    //       method: "POST",
    //       credentials: "include",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${token}`,
    //       },
    //       body: JSON.stringify(filterBody),
    //     })
    //       .then((res) => res.json())
    //       .then((data) => {
    //         if (data.message === "informacion creditos anulados") {
    //           const creditsNewArr = data.data.listaCreditosRet.map((credit) => [
    //             {
    //               field_content: credit.altura + " de " + credit.altura,
    //             },
    //             {
    //               field_content: credit.NombreCliente,
    //             },
    //             {
    //               field_content: credit.vigInicial,
    //             },
    //             {
    //               field_content: credit.noDoc,
    //             },
    //             {
    //               field_content: credit.riesgo,
    //             },
    //             {
    //               field_content: credit.poliza,
    //             },
    //           ]);
    //           setTotalCredits(data.data.cantRegistros);
    //           setCreditList(creditsNewArr);
    //         } else {
    //           setCreditList([]);
    //           setTotalCredits(0);
    //         }
    //       })
    //       .finally(() => {
    //         setLoading(false);
    //       });
    //   } catch (err) {
    //     console.log(err);
    //   }
    // }
  }, 500);

  useEffect(() => {
    debouncedSearch(filterData);
    //eslint-disable-next-line
  }, [maxData, initPage, filterData]);

  const getMaxDataValue = (maxDataVal) => {
    setMaxData(maxDataVal);
  };

  const getPaginationData = (initPageVal) => {
    setInitPage(initPageVal);
  };

  const handleGetFilters = (e) => {
    if (e.target.name === "document_plate") {
      setFilterData({
        ...filterData,
        type: e.target.value !== "" ? "Documento_Placa" : "",
        [e.target.name]: e.target.value,
      });
    }

    if (
      e.target.name === "advisor" ||
      e.target.name === "insurer" ||
      e.target.name === "credit_state"
    ) {
      setFilterData({
        ...filterData,
        type: "FiltrosVarios",
        [e.target.name]: e.target.value,
      });
    }

    setFilterData({
      ...filterData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCleanFilters = () => {
    setFilterData({
      type: "",
      document_plate: "",
      advisor: "",
      insurer: "",
      credit_state: "",
      next_to_renew: "",
    });
  };

  // const exportToExcel = () => {
  //   const jsonData = creditListExcel.map((credit) => {
  //     return {
  //       Altura: credit.altura + " de " + credit.altura,
  //       NombreCliente: credit.NombreCliente,
  //       NoDocumento: credit.noDoc,
  //       PlacaDetalleRiesgo: credit.riesgo,
  //       NoPoliza: credit.poliza,
  //       FechaVigencia: credit.vigInicial,
  //     };
  //   });

  //   const workbook = utils.book_new();

  //   const worksheet = utils.json_to_sheet(jsonData);

  //   utils.book_append_sheet(workbook, worksheet, "Creditos vigentes");

  //   writeFile(workbook, "Creditos vigentes.xlsx");
  // };

  return (
    <section className="current-credit-section">
      <div className="current-credit-subcontainer">
        <div className="cc-title-container">
          <h1 className="cc-title">Gestión Cartera</h1>
        </div>
        <div className="cc-description-txt-container">
          <p className="ccdt-txt">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit
            corporis maiores, laudantium consectetur illo dolore ullam,
            voluptatibus odio culpa mollitia exercitationem quasi vel labore
            quas dolorem repellat officiis aperiam officia?
          </p>
          <p className="ccdt-txt">
            Número de créditos en proceso: {totalCreditInProcess}
          </p>
          <p className="ccdt-txt">
            Número de créditos en mora: {totalDelinquentLoans}
          </p>
          <p className="ccdt-txt">
            Número de créditos vigentes: {totalCurrentCredit}
          </p>
        </div>
        <div className="filter-elms-container">
          <div className="input-container">
            <form onChange={handleGetFilters} className="filter-form-container">
              <label>
                <h1 className="label-title">Número de Documento o Placa:</h1>
                <input
                  className="filter-input-search"
                  type="text"
                  placeholder="Numero de Documento o Placa"
                  title="Numero de Documento o Placa"
                  name="document_plate"
                  value={filterData.document_plate}
                />
              </label>
              {userData?.profile !== "Aseguradora" && (
                <label>
                  <h1 className="label-title">Intermediario:</h1>
                  <select
                    name="insurer"
                    id="insurer"
                    disabled={filterData.document_plate !== "" ? true : false}
                    value={filterData.insurer}
                  >
                    <option value="">--Seleccione--</option>
                  </select>
                </label>
              )}
              <label>
                <h1 className="label-title">Año:</h1>
                <select name="year" id="year" value={filterData.year}>
                  <option value="">--Seleccione--</option>
                  {years}
                </select>
              </label>
              <label>
                <h1 className="label-title">Tipo de Crédito:</h1>
                <select name="credit_type" id="credit_type">
                  <option value="loans_process" selected>
                    Créditos en Proceso
                  </option>
                  <option value="delinquent_loans">Créditos en Mora</option>
                  <option value="current_loans">Créditos Vigentes</option>
                </select>
              </label>
            </form>
            <button
              className="cc-btn-search"
              title="Limpiar Filtros"
              onClick={handleCleanFilters}
            >
              Limpiar Filtros
            </button>
          </div>
        </div>
        {/* <div
          className="ccip-download-excel-container"
          style={{ display: creditList.length > 0 ? "unset" : "none" }}
        >
          <button
            title="Descargar Excel"
            className="ccip-de-btn"
            onClick={() => exportToExcel()}
          >
            Descargar Excel
          </button>
        </div> */}
        <div className="credit-details-table-supercontainer">
          <CreditDetailsTableComponent
            getMaxData={getMaxDataValue}
            maxData={maxData}
            getPaginationInit={getPaginationData}
            credits={creditList}
            totalCreditsNum={totalCredits}
            filterData={filterData}
            fields={tableFields}
          />
        </div>
      </div>
    </section>
  );
};

export default CreditManagerBody;
